<template>
  <div ref="wrapper" class="floating-label-wrapper">
    <!-- your input component goes here -->
    <slot />

    <!-- the label -->
    <!-- <label :class="{ floating: isFloating }">{{ label }}</label> -->
    <label :class="{ floating: isFloating }">
      <slot name="label">
        {{ label }}
      </slot>
    </label>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, defineProps } from 'vue'

const props = defineProps({
  label:     { type: String, required: false,default:'' }, 
  value:     { required: true }
})

/** state for focus/open */
const isFocused = ref(false)
const hasValue  = ref(!!props.value)

/** watch the value prop to update hasValue */
watch(() => props.value, v => {
  hasValue.value = v !== null && v !== undefined && v !== ''
})

/** combined flag: either focused/open OR has a value */
const isFloating = computed(() => isFocused.value || hasValue.value)

/** a ref to the wrapper so we can track focusin/ focusout */
const wrapper = ref(null)

function onFocusIn()  { isFocused.value = true }
function onFocusOut() { isFocused.value = false }

onMounted(() => {
  // listen for any focus events inside the wrapper
  wrapper.value.addEventListener('focusin',  onFocusIn)
  wrapper.value.addEventListener('focusout', onFocusOut)
})

onBeforeUnmount(() => {
  wrapper.value.removeEventListener('focusin',  onFocusIn)
  wrapper.value.removeEventListener('focusout', onFocusOut)
})
</script>

<style scoped>
.floating-label-wrapper {
  position: relative;
  display: block;
   /* display: flex; */
  align-items: center;
  
}

/* position the label over the center of the control */
.floating-label-wrapper > label {
  position: absolute;
  left: 0.0rem;            /* match Bootstrap’s input padding */
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  color: #6c757d;
  pointer-events: none;
  font-size: 18px;
  background: rgba(var(--bs-light-rgb), var(--bs-bg-opacity));
  padding: 0 .25rem;        /* to “cut out” behind the label */
}

/* when floating, push it up and shrink it */
.floating-label-wrapper > label.floating {
  top: 0;                  
  transform: translateY(-50%) scale(0.85);
  transform-origin: top left;
  opacity: 0.85;
}

/* hide border *only* when the select is closed */
.floating-label-wrapper ::v-deep .vs__dropdown-toggle[aria-expanded="false"] {
  border:  1px solid transparent;
  background: transparent !important;
  box-shadow: none !important;
}
/* restore the normal border when it’s open */
.floating-label-wrapper ::v-deep .vs__dropdown-toggle[aria-expanded="true"] {
  /* match Bootstrap’s default form-control styles */
  border: 1px solid var(--bs-border-color);
  background: var(--bs-form-control-bg);
  box-shadow: var(--bs-form-control-box-shadow);
}
</style>
